export { default, default as BannerBody } from './BannerBody'
export * as BannerBodyStyles from './styles/BannerBody.style'

export type { BannerBodyProps } from './BannerBody.types'
export type { StyledBannerBodyProps } from './styles/BannerBody.style.types'
